(function() {
  'use strict';

  var MOBILE_BREAKPOINT = 768;
  var RESIZE_DEBOUNCE_MS = 120;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function debounce(fn, wait) {
    var t;
    return function() {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function() {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function eachCoordinateSection(callback) {
    document.querySelectorAll('.coordinate-section').forEach(callback);
  }

  function positionArrowUnderTrigger(trigger, arrowEl, slot) {
    if (!trigger || !arrowEl || !slot) return;
    var triggerRect = trigger.getBoundingClientRect();
    var slotRect = slot.getBoundingClientRect();
    var triggerCenter = triggerRect.left + triggerRect.width / 2;
    arrowEl.style.left = triggerCenter - slotRect.left + 'px';
    arrowEl.style.transform = 'translateX(-50%)';
    arrowEl.style.display = '';
  }

  function moveExpandContentForViewport(sectionRoot) {
    if (!sectionRoot) return;

    var contents = sectionRoot.querySelectorAll('.coordinate-card__expand-content--desktop');
    var mobile = isMobile();

    contents.forEach(function(content) {
      if (mobile) {
        var rowIndex = content.getAttribute('data-row-index');
        var slot = sectionRoot.querySelector('.coordinate-row__expand-slot--mobile[data-row-index="' + rowIndex + '"]');
        if (slot && content.parentNode !== slot) slot.appendChild(content);
      } else {
        var desktopRowIndex = content.getAttribute('data-desktop-row-index');
        var desktopSlot = sectionRoot.querySelector('.coordinate-row__expand-slot--desktop[data-desktop-row-index="' + desktopRowIndex + '"]');
        if (desktopSlot && content.parentNode !== desktopSlot) desktopSlot.appendChild(content);
      }
    });
  }

  function getOpenTrigger(sectionRoot) {
    return sectionRoot ? sectionRoot.querySelector('.js-coordinate-expand-trigger[aria-expanded="true"]') : null;
  }

  function updateExpandArrowPosition(sectionRoot) {
    if (isMobile() || !sectionRoot) return;
    var trigger = getOpenTrigger(sectionRoot);
    if (!trigger) return;
    var targetId = trigger.getAttribute('aria-controls');
    var content = targetId ? document.getElementById(targetId) : null;
    if (!content) return;
    var desktopRowIndex = content.getAttribute('data-desktop-row-index');
    var slot = sectionRoot.querySelector('.coordinate-row__expand-slot--desktop[data-desktop-row-index="' + desktopRowIndex + '"]');
    var arrowEl = slot ? slot.querySelector('.coordinate-expand-arrow--desktop-row') : null;
    positionArrowUnderTrigger(trigger, arrowEl, slot);
  }

  function hideAllDesktopRowArrows(sectionRoot) {
    sectionRoot.querySelectorAll('.coordinate-expand-arrow--desktop-row').forEach(function(arrow) {
      arrow.style.display = 'none';
    });
  }

  function hideAllMobileArrows(sectionRoot) {
    sectionRoot.querySelectorAll('.coordinate-expand-arrow--mobile').forEach(function(arrow) {
      arrow.style.display = 'none';
    });
  }

  function updateMobileExpandArrow(sectionRoot) {
    if (!isMobile() || !sectionRoot) return;
    hideAllMobileArrows(sectionRoot);
    var trigger = getOpenTrigger(sectionRoot);
    if (!trigger) return;
    var targetId = trigger.getAttribute('aria-controls');
    var content = targetId ? document.getElementById(targetId) : null;
    if (!content) return;
    var rowIndex = content.getAttribute('data-row-index');
    var slot = sectionRoot.querySelector('.coordinate-row__expand-slot--mobile[data-row-index="' + rowIndex + '"]');
    var arrowEl = slot ? slot.querySelector('.coordinate-expand-arrow--mobile') : null;
    positionArrowUnderTrigger(trigger, arrowEl, slot);
  }

  function closeAllExpandedInSection(sectionRoot) {
    sectionRoot.querySelectorAll('.coordinate-card__expand-content:not([hidden])').forEach(function(el) {
      el.setAttribute('hidden', '');
    });
    sectionRoot.querySelectorAll('.js-coordinate-expand-trigger[aria-expanded="true"]').forEach(function(t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  function collapseExpandChrome(sectionRoot) {
    hideAllDesktopRowArrows(sectionRoot);
    hideAllMobileArrows(sectionRoot);
  }

  function initCoordinateExpand(container) {
    var scope = container || document;
    scope.querySelectorAll('.js-coordinate-expand-trigger').forEach(function(trigger) {
      if (trigger.getAttribute('data-coordinate-expand-initialized') === 'true') return;
      trigger.setAttribute('data-coordinate-expand-initialized', 'true');
      trigger.addEventListener('click', function() {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var targetId = trigger.getAttribute('aria-controls');
        var content = targetId ? document.getElementById(targetId) : null;
        var sectionRoot = trigger.closest('.coordinate-section');
        if (!content || !sectionRoot) return;

        if (expanded) {
          content.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
          collapseExpandChrome(sectionRoot);
          return;
        }

        closeAllExpandedInSection(sectionRoot);
        collapseExpandChrome(sectionRoot);

        moveExpandContentForViewport(sectionRoot);

        content.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');

        requestAnimationFrame(function() {
          if (isMobile()) {
            updateMobileExpandArrow(sectionRoot);
          } else {
            updateExpandArrowPosition(sectionRoot);
          }
        });
      });
    });
  }

  function refreshSectionLayout(sectionRoot) {
    moveExpandContentForViewport(sectionRoot);
    updateExpandArrowPosition(sectionRoot);
    updateMobileExpandArrow(sectionRoot);
  }

  var debouncedResize = debounce(function() {
    eachCoordinateSection(refreshSectionLayout);
  }, RESIZE_DEBOUNCE_MS);

  function init() {
    initCoordinateExpand();
    eachCoordinateSection(refreshSectionLayout);
    window.addEventListener('resize', debouncedResize);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var trigger = document.querySelector('.coordinate-section .js-coordinate-expand-trigger[aria-expanded="true"]');
    if (!trigger) return;
    var sectionRoot = trigger.closest('.coordinate-section');
    var targetId = trigger.getAttribute('aria-controls');
    var content = targetId ? document.getElementById(targetId) : null;
    if (content) content.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
    collapseExpandChrome(sectionRoot);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(evt) {
    var sectionId = evt.detail && evt.detail.sectionId;
    var root = sectionId ? document.getElementById('shopify-section-' + sectionId) : evt.target;
    if (!root || !root.querySelector('.js-coordinate-expand-trigger')) return;
    initCoordinateExpand(root);
    refreshSectionLayout(root);
  });
})();
